import request from 'superagent'

import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'

export default
{
    name: 'app-input-email',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    props: {
        label: { type: String, default: 'Your email' },
        labelFor: { type: String, default: 'email' }
    },

    data() {
        return {
            value: '',
            isSending: false,
            message: {
                active: false,
                type: '',
                content: 'Something went wrong. Please try again.'
            }
        }
    },

    created() {
        this.eventHub.$on('page-home:onActiveIndexChange', this.onActiveIndexChange)
    },

    mounted() {
        this.$el.querySelector('.js-input-email').addEventListener('focus', this.inputIsFocused)
        this.$el.querySelector('.js-input-email').addEventListener('blur', this.inputIsBlured)
    },

    destroyed() {
        this.eventHub.$off('page-home:onActiveIndexChange', this.onActiveIndexChange)
        this.$el.querySelector('.js-input-email').removeEventListener('focus', this.inputIsFocused)
        this.$el.querySelector('.js-input-email').removeEventListener('blur', this.inputIsBlured)
    },

    methods: {
        onActiveIndexChange() {
            setTimeout(this._hideErrorMessage, 1000)
        },

        inputIsFocused() {
            this.$el.querySelector('.js-input-email-container').classList.add('is-focused')
        },

        inputIsBlured() {
            this.$el.querySelector('.js-input-email-container').classList.remove('is-focused')
        },

        _submitForm() {
            if (!this._isValidEmail(this.value)) {
                this.message.active = true
                this.message.type = 'error'
                this.message.content = 'Please enter a valid email address.'
            } else {
                this.isSending = true

                const data = {
                    email: this.$el.querySelector('.js-input-email').value,
                    status: 'subscribed'
                }

                this.message.active = false
                this.message.type = 'success'
                this.message.content = 'Thank you, you have been added to our mailing list.'

                request
                    .post('/static/api/subscribe.php')
                    .send(data)
                    .type('form')
                    .end((error, response) => {
                        if (!error && response.body && (response.body.error === 0 || response.body.error === 2)) {
                            this.message.active = true
                            this.message.type = 'success'
                            this.message.content = 'Thank you, you have been added to our mailing list.'
                        } else {
                            this.message.active = true
                            this.message.type = 'error'
                            this.message.content = 'Oops! We had a problem adding you to the list, please try again.'
                        }

                        this.isSending = false
                    })
            }
        },

        _isValidEmail(email) {
            const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return reg.test(email)
        },

        _hideErrorMessage() {
            this.message.active = false
            this.message.type = ''
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-input-email/script.js